import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

export enum ZenAiMessageStatus {
  Reasoning = 'reasoning', // Shimmer box for temporary reasoning/status messages (cleared on Complete/Error)
  Complete = 'complete', // Final complete message box
}

export interface ZenAiMessage {
  text: string;
  isUser: boolean;
  timestamp: Date;
  status: ZenAiMessageStatus; // Explicit status for all messages
  url?: string;
  formattedText?: SafeHtml;
}

@Component({
  selector: 'app-zen-ai-message',
  templateUrl: './zen-ai-message.component.html',
  styleUrls: ['./zen-ai-message.component.scss'],
})
export class ZenAiMessageComponent {
  @Input() message!: ZenAiMessage;
}
